<template>
  <b-row v-if="$route.name === 'EXSBOrderShow'">
    <b-col>
      <Loader v-if="isLoading" size="lg"></Loader>
      <b-row v-else-if="item">
        <b-col>
          <b-row>
            <b-col>
              <router-link v-if="item" :to="{ name: 'EXSBOrderList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card>
                <div class="h6">
                  {{$t('views.exsborder.show.title')}}
                  <span v-if="orderStatusId === 1"><b-badge variant="primary">{{ item.orderStatus.name }}</b-badge></span>
                  <span v-else-if="orderStatusId === 2"><b-badge variant="secondary">{{ item.orderStatus.name }}</b-badge></span>
                  <span v-else-if="orderStatusId === 3"><b-badge variant="dark">{{ item.orderStatus.name }}</b-badge></span>
                  <span v-else-if="orderStatusId === 4"><b-badge variant="success">{{ item.orderStatus.name }}</b-badge></span>
                  <span v-else-if="orderStatusId === 5"><b-badge variant="danger">{{ item.orderStatus.name }}</b-badge></span>
                </div>
                <hr class="mt-0 mb-0">
                <div class="card-body">
                  <b-row>
                    <b-col>
                      <!--<p>{{$t('views.exsborder.show.orderStatus')}}: <b>{{ item.orderStatus.name }}</b></p>-->
                      <p>{{$t('views.exsborder.show.contractor')}}: <b>{{ item.firm.firmname1 === '' ? item.firm.fullName : item.firm.firmname1 }}</b></p>
                    </b-col>
                  </b-row>
                  <b-row v-if="item.orderTags.length > 0">
                    <b-col>
                      <p>{{$t('views.exsborder.list.tags')}}: {{ getOrderTags(item) }}</p>
                    </b-col>
                  </b-row>
                  <b-row v-if="item.positions.length > 0">
                    <b-col>
                      <b-row>
                        <b-col>
                        <h6>{{$t('views.exsborder.show.orderPositions')}}:</h6>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <positions-table :positions="item['positions']"></positions-table>
                        </b-col>
                      </b-row>
                      <b-row v-if="ableToEditOrder">
                        <b-col>
                          <b-btn v-if="orderStatusId === 1" @click="changeOrderStatus('acceptOrder')" variant="primary">{{ $t('buttons.acceptOrder') }}</b-btn>
                          <b-btn v-else-if="orderStatusId === 2" @click="changeOrderStatus('realizeOrder')" variant="secondary">{{ $t('buttons.realizeOrder') }}</b-btn>
                          <b-btn v-else-if="orderStatusId === 3" @click="changeOrderStatus('finishOrder')" variant="success">{{ $t('buttons.finishOrder') }}</b-btn>
                          <b-btn v-if="orderStatusId < 3" @click="changeOrderStatus('cancelOrder')" variant="danger">{{ $t('buttons.cancelOrder') }}</b-btn>
                          <b-btn v-if="orderStatusId >= 3 && orderStatusId !== 5 && !item.document" @click="generateDocumentForOrder()">{{ $t('views.exsborder.show.generateDocumentForOrder') }}</b-btn>
                          <b-btn v-if="orderStatusId >= 3 && orderStatusId !== 5 && item.document" @click="showDocument()">{{ $t('views.exsborder.show.showDocumentForOrder') }}</b-btn>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <GenerateDocumentForOrderModal></GenerateDocumentForOrderModal>
    </b-col>
  </b-row>
  <div v-else>
    <Loader v-if="isLoading"></Loader>
    <div v-else>
      <div class="h6">
        {{$t('views.exsborder.show.title')}}
        <span v-if="orderStatusId === 1"><b-badge variant="primary">{{ item.orderStatus.name }}</b-badge></span>
        <span v-else-if="orderStatusId === 2"><b-badge variant="secondary">{{ item.orderStatus.name }}</b-badge></span>
        <span v-else-if="orderStatusId === 3"><b-badge variant="dark">{{ item.orderStatus.name }}</b-badge></span>
        <span v-else-if="orderStatusId === 4"><b-badge variant="success">{{ item.orderStatus.name }}</b-badge></span>
        <span v-else-if="orderStatusId === 5"><b-badge variant="danger">{{ item.orderStatus.name }}</b-badge></span>
      </div>
      <hr class="mt-0 mb-0">
      <div class="card-body">
        <b-row>
          <b-col>
            <!--<p>{{$t('views.exsborder.show.orderStatus')}}: <b>{{ item.orderStatus.name }}</b></p>-->
            <p>{{$t('views.exsborder.show.contractor')}}: <b>{{ item.firm.firmname1 === '' ? item.firm.fullName : item.firm.firmname1 }}</b></p>
          </b-col>
        </b-row>
        <b-row v-if="item.orderTags.length > 0">
          <b-col>
            <p>{{$t('views.exsborder.list.tags')}}: {{ getOrderTags(item) }}</p>
          </b-col>
        </b-row>
        <b-row v-if="item.positions.length > 0">
          <b-col>
            <b-row>
              <b-col>
                <h6>{{$t('views.exsborder.show.orderPositions')}}:</h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <positions-table :positions="item['positions']"></positions-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import GenerateDocumentForOrderModal from './components/GenerateDocumentForOrder/GenerateDocumentForOrderModal'
import ApiService from '@/utils/ApiService'
import PositionsTable from '@/components/Dashboard/Views/BusinessBundle/exsborder/components/PositionsTable'

export default {
  components: {
    Loader,
    GenerateDocumentForOrderModal,
    PositionsTable
  },
  computed: {
    ableToEditOrder () {
      return checkPermission('orders', 'EXSBOrderUpdate')
    },
    ...mapGetters({
      updated: 'exsborder/update/updated',
      deleteError: 'exsborder/del/error',
      error: 'exsborder/show/error',
      isLoading: 'exsborder/show/isLoading',
      item: 'exsborder/show/retrieved'
    }),
    orderStatusId: function () {
      return parseInt(this.getIdLink(this.item.orderStatus['@id']))
    }
  },

  props: ['idOrder'],

  data () {
    return {
      selectedPositions: []
    }
  },

  beforeDestroy () {
    this.reset()
  },

  beforeCreate () {
    checkPagePermission('orders', 'EXSBOrderShow')
  },

  created () {
    if (this.idOrder) {
      this.retrieve(this.idOrder)
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      update: 'exsborder/update/update',
      del: 'exsborder/del/del',
      reset: 'exsborder/show/reset',
      retrieve: 'exsborder/show/retrieve'
    }),

    generateDocumentForOrder () {
      this.$store.state.modals.exsborder.generateDocument.show = 1
      this.$store.state.modals.exsborder.generateDocument.order = Object.assign({}, this.item)
    },

    async changeOrderStatus (changeType) {
      let item = Object.assign({}, this.item)
      if (changeType === 'cancelOrder') {
        item.orderStatus = '/api/e_x_s_b_order_statuses/5'
      } else if (changeType === 'acceptOrder') {
        item.orderStatus = '/api/e_x_s_b_order_statuses/2'
      } else if (changeType === 'realizeOrder') {
        item.orderStatus = '/api/e_x_s_b_order_statuses/3'
      } else if (changeType === 'finishOrder') {
        item.orderStatus = '/api/e_x_s_b_order_statuses/4'
      }
      delete item.positions
      delete item.firm
      delete item.valueNetto
      delete item.valueBrutto

      const response = await new ApiService(`e_x_s_b_orders/${getId(this.item['@id'])}`).put(item)
      if (response.status === 200) {
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    },
    showDocument () {
      this.$router.push({ name: 'EXSBDocumentShow', params: { id: this.item.document } })
    },
    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBOrderList' }))
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    getOrderTags (order) {
      return order.orderTags.map(orderTag => {
        return orderTag.tag.tag
      }).join(', ')
    }
  }
}
</script>
